import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface ISidebar {
    mobileOpen: boolean;
    desktopOpen: boolean;
    link: string;
};

export const SidebarSlice = createSlice<ISidebar, MapReducerPayloads<ISidebar, {
    setMobileOpen: boolean;
    setDesktopOpen: boolean;
    setLink: string;
}>>({
    name: "sidebar",
    initialState: {
        desktopOpen: false,
        mobileOpen: false,
        link: ""
    },
    reducers: {
        setDesktopOpen: (state, action) => {
            state.desktopOpen = action.payload
        },
        setMobileOpen: (state, action) => {
            state.mobileOpen = action.payload
        },
        setLink: (state, action) => {
            state.link = action.payload
        },
    }
});